export const generateCssClassName = (label: string): string => {
  return label.toLowerCase().split(' ').join('-')
}
